import { formatIDR } from "@/lib/format";

export const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;

export const waDisplayNumber = () => {
  const n = WA_NUMBER || "";
  return n.startsWith("62") ? `+${n.slice(0, 2)} ${n.slice(2, 5)}-${n.slice(5, 9)}-${n.slice(9)}` : n;
};

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const waProductMessage = (product) =>
  `Halo Zoya Beads, saya mau pesan *${product.name}* (${formatIDR(product.price)}). Apakah masih tersedia?`;

export const waListMessage = (items) => {
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);
  return [
    "Halo Zoya Beads, saya mau pesan:",
    "",
    ...items.map((i) => `• ${i.name} x${i.qty} — ${formatIDR(i.price * i.qty)}`),
    "",
    `Total: ${formatIDR(total)} (belum termasuk ongkir)`,
    "",
    "Mohon info ketersediaan dan cara pembayarannya. Terima kasih!",
  ].join("\n");
};

export const waCustomMessage = () =>
  [
    "Halo Zoya Beads, saya mau custom gelang:",
    "",
    "Warna yang diinginkan: ",
    "Charm / bandul: ",
    "Ukuran lingkar tangan (cm): ",
    "Jumlah: ",
    "Untuk acara / tanggal dibutuhkan: ",
    "",
    "Terima kasih!",
  ].join("\n");
